import { render, staticRenderFns } from "./DhxGrid.vue?vue&type=template&id=49cc7879"
import script from "./DhxGrid.vue?vue&type=script&lang=js"
export * from "./DhxGrid.vue?vue&type=script&lang=js"
import style0 from "./DhxGrid.vue?vue&type=style&index=0&id=49cc7879&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports